import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NumberAttributeFilter } from 'app/shared/ui/models/number-attribute-filter';

@Component({
  selector: 'jhi-number-filter',
  templateUrl: './number-filter.component.html',
  styleUrls: ['./number-filter.component.scss'],
})
export class NumberFilterComponent {
  @Input() filter!: NumberAttributeFilter;
  @Output() filterChange = new EventEmitter<NumberAttributeFilter>();
}
